import { useEffect, useState } from "react";
import axios from "../../utils/axiosInstance";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from "recharts";

const Sales = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const fetchReport = async () => {
    try {
      setLoading(true);
      const params = {};
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;

      const res = await axios.get("/reports/sales", { params });
      setData(res.data);
      console.log("Sales Report:", res.data);
    } catch (err) {
      console.error("Error loading sales report", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport();
  }, []);

  return (
    <div className="container my-4">
      <h2 className="mb-4 fw-bold text-primary">
         Sales and Revenue Overview
      </h2>

      {/* 🔹 فیلتر تاریخ */}
      <div className="card shadow-sm mb-4">
        <div className="card-body">
          <div className="row g-3 align-items-end">
            <div className="col-md-3">
              <label className="form-label">From</label>
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="col-md-3">
              <label className="form-label">To</label>
              <input
                type="date"
                className="form-control"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <button
                className="btn btn-primary w-100"
                onClick={fetchReport}
                disabled={loading}
              >
                {loading ? "Loading..." : "Apply"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* 🔹 لاودینگ */}
      {loading && !data && (
        <div className="text-center my-5">
          <div className="spinner-border text-primary" />
          <p className="mt-2">Loading sales report...</p>
        </div>
      )}

      {/* 🔹 محتوای گزارش */}
      {data && (
        <>
          {/* کارت‌های آماری */}
          <div className="row g-3 mb-4">
            <div className="col-md-4">
              <div className="card text-white bg-success shadow-sm">
                <div className="card-body text-center">
                  <h6>Total Income</h6>
                  <h3>${data.grossRevenue}</h3>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card text-white bg-primary shadow-sm">
                <div className="card-body text-center">
                  <h6>Net Income</h6>
                  <h3>${data.netRevenue}</h3>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card text-white bg-warning shadow-sm">
                <div className="card-body text-center">
                  <h6>Avg Order Value</h6>
                  <h3>${data.aov.toFixed(2)}</h3>
                </div>
              </div>
            </div>
          </div>

          {/* 🔹 نمودار فروش ماهانه */}
          <div className="card shadow-sm mb-4">
            <div className="card-body">
              <h5 className="mb-3 text-secondary">Monthly Sales</h5>
              <div style={{ width: "100%", height: 300 }}>
                <ResponsiveContainer>
                  <BarChart data={data.salesData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="month" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="sales" fill="#0d6efd" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>

          {/* 🔹 جدول وضعیت سفارش‌ها */}
          <div className="card shadow-sm mb-4">
            <div className="card-body">
              <h5 className="mb-3 text-secondary">Orders by Status</h5>
              <div className="table-responsive">
                <table className="table table-bordered table-striped align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>Status</th>
                      <th>Orders Count</th>
                      <th>Total Revenue ($)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.ordersByStatus.map((s) => (
                      <tr key={s._id}>
                        <td className="fw-semibold">{s._id}</td>
                        <td>{s.count}</td>
                        <td>${s.revenue}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Sales;
